import { styled } from 'goober';

export const SelectContainer = styled('div')(() => ({
    position: 'relative',
}));

export const SelectOptions = styled('div')<{ $placement?: 'leftBottom' | 'centerBottom' | 'rightBottom' }>(
    ({ theme, $placement = 'leftBottom' }) => ({
        padding: '8px',
        position: 'absolute',
        top: 'calc(100% + 10px)',
        backgroundColor: '#fff',
        border: `1px solid ${theme.borderColor}`,
        borderRadius: theme.borderRadius,
        boxShadow: 'rgb(107 131 160 / 15%) 0px 4px 16px',
        left: $placement === 'rightBottom' ? '0' : $placement === 'centerBottom' ? '50%' : 'auto',
        right: $placement === 'leftBottom' ? '0' : 'auto',
        transform: $placement === 'centerBottom' ? 'translate(-50%, 0)' : 'none',
        zIndex: theme.zIndex.DROPDOWN,
    })
);

export const SelectOption = styled('div')<{ $disabled?: boolean }>(({ theme, $disabled = false }) => ({
    padding: '5px 10px',
    fontSize: theme.font.size,
    lineHeight: '22px',
    cursor: $disabled ? 'not-allowed' : 'pointer',
    whiteSpace: 'nowrap',
    opacity: $disabled ? 0.4 : 1,
    borderRadius: theme.borderRadius,
    '&:hover': {
        backgroundColor: $disabled ? 'transparent' : theme.colors.neutral.w100,
    },
}));
